export const decodeMacros = (text: string) => text
            // revert the ${____}
            .replace(/((%24)?%7B.*?%7D)/g, (_, match) => decodeURIComponent(match))
            // revert the []
            .replace(/(%5B.*?%5D)/g, (_, match) => decodeURIComponent(match))